export const integer = (num: number) => Math.floor(num);
